/* eslint-disable array-callback-return */
import React, { useEffect, useState, useCallback } from "react";
import DashboardPage from "../../../layout";
import { getGlobalFilter } from "../../../api/filters";
import PaginationComponent from "../../../components/Pagination";
import Loader from "../../../components/Loader";
import Export from "../../../assets/icons/Export.svg";
import Filter from "../../../assets/icons/Filter.svg";
import Eye from "../../../assets/eye.svg";
import {
  formatCurrentStartDate,
  formatCurrentEndDate,
  getPagePerSize,
  formatDate,
  formatMinutes,
  getUserInfo,
  printElement,
} from "../../../utility";
import TimeFrameSelector from "../../../components/TimeFrameSelector";
import { useTranslation } from "react-i18next";
import Close from "../../../assets/close-circle.svg";
import Search from "../../../assets/Search.svg";
import { useNavigate } from "react-router-dom";
import { TimeZoneDisplay } from "../../../utility";
import ImageDailog from "../../../components/ImageDailog";
import Dropdown from "../../../components/Dropdown";
import DropdownMulti from "../../../components/DropdownMultiple";
import Button from "../../../components/Button";
import { getPlanningReport, getDeliveryProofPresignedUrl } from "../../../api/delivery-driver";
import debounce from "lodash/debounce";
import { toast } from "react-toastify";
import ComponentToPrint from "./ComponentToPrint";

import { delivery_man } from "../../../utility/constant";
import moment from "moment";

const formatAreaStreet = (item: { area?: string; street?: string }) => {
  if (item.area && item.street) return `${item.area} / ${item.street}`;
  return item.area ?? item.street ?? "-";
};

const formatCollectionAmount = (value: any) => {
  if (value == null || value === "") return "-";
  const num = Number(value);
  if (isNaN(num) || num < 0) return "0.00";
  return num.toFixed(2);
};

const formatQuantity = (value: any) => {
  if (value == null || value === "" || value === "-") return "-";
  const num = Number(value);
  if (isNaN(num)) return value;
  return Math.round(num);
};

const PlanningReport: React.FC = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [open, setOpen] = useState(false);
  const [employees, setEmployeesData] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [loadingFilter, setLoadingForFilter] = useState(false);
  const [timeFrame, setSelectTimeFrame] = useState<any>("Today");
  const [startDate, setStartDate] = useState<any>(new Date());
  const [endDate, setEndDate] = useState<any>(new Date());
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [sortType, setSortType] = useState<any>("");
  const { t } = useTranslation();
  const [globalFilters, setGlobalFilters] = useState<any>(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedEmpId, setSelectedEmpId] = useState<any>("");
  const [selectedEmpStatus, setSelectedEmpStauts] = useState<any>("");
  const [selectedSalesOffice, setSelectedSalesOffice] = useState<any>("");
  const [selectedRegion, setRegion] = useState<any>("");
  const [DeliveryStatus, setDeliveryStatus] = useState<any>("");
  const [deliveryType, setDeliveryType] = useState<any>("");
  const [territoryId, setTerritoryId] = useState<any>([]);
  const [routeId, setRouteId] = useState<any>([]);
  const [userType, setUserType] = useState<any>("");
  const [channelId, setChannelId] = useState<any>([]);
  const [viewImg, setViewImg] = useState<any>(false);
  const [imgUrl, setImgUrl] = useState<any>();
  const [imgType, setImgType] = useState<any>();
  const [imageLoading, setImageLoading] = useState(false);
  const startIndex = (currentPage - 1) * employees?.size;
  const navigate = useNavigate();
  const employeesPerPage = getPagePerSize();
  const [filtersApplied, setFiltersApplied] = useState(false);
  const [landingMessage, setLandingMessage] = useState<string>("Apply a filter to see the data.");
  const [printableData, setPrintableData] = useState<any>();
  const [printHeaderInfo, setPrintHeaderInfo] = useState<any>();
  const [printing, setPrinting] = useState(false);
  const getGlobalFilters = async (data: any) => {
    try {
      setLoadingForFilter(true);
      const response = await getGlobalFilter({ ...data, planned_users: true });
      setLoadingForFilter(false);
      setGlobalFilters(response);
    } catch (error) {
      console.error("Error fetching global filters:", error);
    }
  };

  const handleFilterClick = () => {
    setOpen(true);
  };

  const handleChange = (event: any) => {
    setSearchQuery(event);
    updateSearchTerm(event);
  };

  const handleSortFillter = (data: string) => {
    if (data === sortType) {
      setSortType("");
      handleApply("");
    } else {
      setSortType(data);
      handleApply(data);
    }

    setIsDropdownOpen(false);
  };

  function getCurrentDate() {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  const handleClose = () => setOpen(false);

  const handleClearFilters = () => {
    setSelectedEmpId("");
    setSelectedSalesOffice("");
    setRegion("");
    setDeliveryStatus("");
    setDeliveryType("");
    setTerritoryId([]);
    setRouteId([]);
    setUserType(null);
    setChannelId([]);
    setSelectedEmpStauts(null);
    setStartDate(getCurrentDate());
    setEndDate(getCurrentDate());
    setSelectTimeFrame("Today");
    setOpen(false);
    setFiltersApplied(false);
    setLandingMessage("Apply a filter to see the data.");
    handleClearApply("");
  };

  const handleClearApply = (sort: string) => {
    // Clear the data when filters are cleared
    setEmployeesData({ items: [], total: 0, size: employeesPerPage });
    setCurrentPage(1);
    handleClose();
  };

  const getPayload = (data: any) => {
    if (selectedEmpStatus) {
      data["status"] = selectedEmpStatus;
    }

    if (channelId.length > 0) {
      data["channel_ids"] = channelId;
    }
    if (selectedRegion) {
      data["regions"] = [selectedRegion];
    }
    if (DeliveryStatus.length > 0) {
      data["status"] = DeliveryStatus;
    }
    if (routeId.length > 0) {
      data["route_ids"] = routeId;
    }
    if (selectedSalesOffice) {
      data["sales_office_ids"] = [selectedSalesOffice];
    }
    if (selectedEmpId) {
      data["subordinate_ids"] = [selectedEmpId];
    }
    if (territoryId.length > 0) {
      data["territory_ids"] = territoryId;
    }
    if (userType) {
      data["user_type"] = userType;
    }
    if (deliveryType) {
      data["delivery_visit_type"] = deliveryType;
    }

    data["start_date"] = formatCurrentStartDate(new Date(startDate));
    data["end_date"] = formatCurrentEndDate(new Date(endDate));
    data["positions"] = [delivery_man];
  };

  const getSelectedSalesOfficeDisplay = () => {
    if (!selectedSalesOffice) {
      return "-";
    }
    const selectedOffice = globalFilters?.sales_offices?.find(
      (so: any) => String(so.id) === String(selectedSalesOffice)
    );
    if (!selectedOffice) return "-";
    return `${selectedOffice.id} / ${selectedOffice.name}`;
  };

  const getPrintHeaderInfo = (data?: any) => {
    const firstItem = data?.items?.[0];
    const selectedEmployee = globalFilters?.employees?.find(
      (emp: any) =>
        selectedEmpId && String(selectedEmpId) === String(emp.id)
    );

    // Use selected sales office from filters
    const salesOfficeDisplay = getSelectedSalesOfficeDisplay();

    // Get current user info for "Printed By"
    const userInfo = getUserInfo();
    const printedBy = userInfo?.name_eng || userInfo?.name || userInfo?.email || "-";

    // Current timestamp for "Printed at"
    const now = new Date();
    const printedAt = `${now.toLocaleDateString('en-GB')} ${now.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}`;

    return {
      employeeId: firstItem?.emp_id ?? selectedEmployee?.id ?? "-",
      employeeName: firstItem?.emp_name ?? selectedEmployee?.name_eng ?? "-",
      salesOfficeDisplay,
      printedAt,
      printedBy,
    };
  };

  const handleExport = async () => {
    setLoading(true);
    const data: any = {
      export: true,
      time_zone: TimeZoneDisplay(),
    };

    if (searchQuery) {
      data["search"] = searchQuery;
    }
    if (sortType) {
      data["sort_by"] = sortType;
    }
    getPayload(data);

    const params = {};
    try {
      await exportActiviyData(data, params);
    } catch (error) {
      console.error("Error exporting data:", error);
    } finally {
      setLoading(false);
    }
  };

  const exportActiviyData = async (data: any, params: any) => {
    await getPlanningReport(params, data).catch((error) => {
      console.error("Error exporting data:", error);
    });
  };

  const isEmployeeSelected = !!selectedEmpId || !!searchQuery;

  const printData = async () => {
    // Restrict print: sales office must be selected
    if (!selectedSalesOffice) {
      toast.warn("Please select a Sales Office before printing.");
      return;
    }
    // Restrict print: employee must be selected
    if (!isEmployeeSelected) {
      toast.warn("Please select an Employee or search by Employee ID before printing.");
      return;
    }

    setPrinting(true);
    const data: any = {
      is_print: true,
    };

    if (searchQuery) {
      data["search"] = searchQuery;
    }
    if (sortType) {
      data["sort_by"] = sortType;
    }
    getPayload(data);

    const params = {
      page: currentPage,
      size: employeesPerPage,
    };

    try {
      const res = await getPlanningReport(params, data);
      setPrintHeaderInfo(getPrintHeaderInfo(res.data));
      setPrintableData(res.data);

      // Wait for React to render the print content
      setTimeout(async () => {
        await printElement("print-content");
        setPrintableData(undefined);
      }, 500);
    } catch (error) {
      console.error("Error fetching print data:", error);
    } finally {
      setPrinting(false);
    }
  };
  const handleSetImage = async (url: any, type: string) => {
    try {
      setImageLoading(true);
      const presignedUrl = await getDeliveryProofPresignedUrl(url);
      setImgUrl(presignedUrl);
      setViewImg(true);
      setImgType(type);
    } catch (error) {
      setImgUrl(null);
      setViewImg(false);
    } finally {
      setImageLoading(false);
    }
  };
  const getDeliveryData = async (data: any, params: any) => {
    setLoading(true);
    await getPlanningReport(params, data)
      .then((res) => {
        setEmployeesData(res.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching Employee data:", error);
        setLoading(false);
      });
  };

  const handleStartDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selected = e.target.value;
    setStartDate(selected);
    setEndDate(selected);
    checkTimeFrame(selected, selected);
  };

  useEffect(() => {
    // Only call API if filters have been applied
    if (filtersApplied) {
      const data: any = {};

      if (searchQuery) {
        data["search"] = searchQuery;
      }

      getPayload(data);

      const params = {
        page: currentPage,
        size: employeesPerPage,
      };
      getDeliveryData(data, params);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, filtersApplied]);

  useEffect(() => {
    const data: any = {};

    if (selectedRegion) {
      data["regions"] = [selectedRegion];
    }
    if (DeliveryStatus.length > 0) {
      data["status"] = DeliveryStatus;
    }
    if (selectedSalesOffice) {
      data["sales_office_ids"] = [selectedSalesOffice];
    }
    if (selectedEmpId) {
      data["subordinate_ids"] = [selectedEmpId];
    }
    if (territoryId.length > 0) {
      data["territory_ids"] = territoryId;
    }
    if (routeId.length > 0) {
      data["route_ids"] = routeId;
    }
    data["endpoint"] = "visit-summary";
    data["start_date"] = formatCurrentStartDate(new Date(startDate));
    data["end_date"] = formatCurrentEndDate(new Date(endDate));
    data["positions"] = [delivery_man];
    getGlobalFilters(data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleFiltersUpdate = () => {
    const data: any = {};

    if (selectedRegion) {
      data["regions"] = [selectedRegion];
    }
    if (DeliveryStatus.length > 0) {
      data["status"] = DeliveryStatus;
    }
    if (selectedSalesOffice) {
      data["sales_office_ids"] = [selectedSalesOffice];
    }
    if (selectedEmpId) {
      data["subordinate_ids"] = [selectedEmpId];
    }
    if (territoryId.length > 0) {
      data["territory_ids"] = territoryId;
    }
    if (routeId.length > 0) {
      data["route_ids"] = routeId;
    }
    data["endpoint"] = "visit-summary";
    data["start_date"] = formatCurrentStartDate(new Date(startDate));
    data["end_date"] = formatCurrentEndDate(new Date(endDate));
    data["positions"] = [delivery_man];
    getGlobalFilters(data);
  };

  const updateSearchTerm = useCallback(
    debounce((value: string) => {
      const data: any = {};

      if (value) {
        data["search"] = value;
      }
      getPayload(data);
      const params = {
        page: 1,
        size: employeesPerPage,
      };
      setCurrentPage(1);
      getDeliveryData(data, params);
    }, 500),
    [
      startDate,
      endDate,
      selectedEmpStatus,
      channelId,
      selectedRegion,
      DeliveryStatus,
      routeId,
      selectedSalesOffice,
      selectedEmpId,
      territoryId,
      userType,
      sortType,
      employeesPerPage,
    ]
  );

  const handleApply = (sort: string) => {
    if (!selectedSalesOffice) {
      toast.warn("Please select a Sales Office.");
      return;
    }
    setCurrentPage(1);
    setFiltersApplied(true);
    const data: any = {};
    if (searchQuery) {
      data["search"] = searchQuery;
    }
    getPayload(data);
    if (sort) {
      data["sort_by"] = sort;
    }
    const params = {
      page: 1,
      size: employeesPerPage,
    };
    getDeliveryData(data, params);
    handleClose();
  };

  const checkTimeFrame = (start: any, end: any) => {
    if (start === formatDate(new Date()) && end === formatDate(new Date())) {
      setSelectTimeFrame("Today");
    } else if (
      start === formatDate(new Date().setDate(new Date().getDate() - 1)) &&
      end === formatDate(new Date().setDate(new Date().getDate() - 1))
    ) {
      setSelectTimeFrame("Yesterday");
    } else {
      setSelectTimeFrame("");
    }
  };

  const isDeliveryWithinTimeSlot = (deliveryTimestamp: string, timeSlot: string) => {
    if (!deliveryTimestamp || !timeSlot) return false;

    try {
      // Parse the delivery timestamp
      const deliveryTime = moment(deliveryTimestamp);
      if (!deliveryTime.isValid()) return false;

      // Parse the time slot (format: "HH:mm-HH:mm")
      const [startTimeStr, endTimeStr] = timeSlot.split('-');
      if (!startTimeStr || !endTimeStr) return false;

      // Get the date from delivery timestamp
      const deliveryDate = deliveryTime.format('YYYY-MM-DD');

      // Create moment objects for start and end times on the same date
      const startTime = moment(`${deliveryDate} ${startTimeStr}`, 'YYYY-MM-DD HH:mm');
      const endTime = moment(`${deliveryDate} ${endTimeStr}`, 'YYYY-MM-DD HH:mm');

      if (!startTime.isValid() || !endTime.isValid()) return false;

      // Check if delivery time falls within the time slot
      return deliveryTime.isBetween(startTime, endTime, null, '[]'); // '[]' includes the boundaries
    } catch (error) {
      console.error('Error checking time slot:', error);
      return false;
    }
  };

  useEffect(() => {
    setSelectedSalesOffice("");
    setTerritoryId([]);
    setRouteId([]);
    setSelectedEmpId("");
  }, [selectedRegion]);

  useEffect(() => {
    setTerritoryId([]);
    setRouteId([]);
    setSelectedEmpId("");
  }, [selectedSalesOffice]);

  useEffect(() => {
    setRouteId([]);
    setChannelId([]);
    setSelectedEmpId("");
  }, [territoryId]);

  useEffect(() => {
    if (selectedEmpId) {
      const emp = globalFilters?.employees?.find((e: any) => String(selectedEmpId) === String(e.id));
      setUserType(emp ? emp.position : "");
    } else {
      setUserType("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedEmpId]);

  return (
    <DashboardPage>
      <div className="bg-gray-50  sm:pl-0 pr-4 ">
        {/* Report Title */}
        <div className="bg-white p-4 border-b-2">
          <h1 className="text-l font-bold text-gray-800">
            Delivery Runsheet
          </h1>
        </div>
        <div className="hidden mb-2 sm:flex flex-col sm:flex-row justify-between items-center bg-white p-2 border-b-2">
          <div className="w-full sm:w-auto mb-4 sm:mb-0 pl-6">
            <PaginationComponent
              totalCount={employees?.total}
              itemsPerPage={employees?.size}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
            />
          </div>

          <div className="flex flex-col sm:flex-row items-center w-full sm:w-auto space-y-4 sm:space-y-0 sm:space-x-4">
            <div className="relative w-full sm:w-auto">
              <div className="absolute inset-y-0 left-0 flex items-center pl-3">
                {/* Add your search icon here */}
                <img src={Search} alt="search" />
              </div>
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => handleChange(e.target.value)}
                placeholder={t("planogram.search")}
                className="w-full sm:w-auto pl-10 pr-4 py-2 text-16 border rounded text-gray-600"
                style={{ borderColor: "#e0e0e0" }}
              />
            </div>

            {/* Buttons group for desktop */}
            <div className="hidden sm:flex space-x-4 items-center">
              {/* <button
                onClick={handleSort}
                className="flex items-center px-4 py-2 text-16 text-gray-600 rounded transition-all"
              >
                <img src={Sort} alt="Sort Icon" className="w-4 h-4 mr-2" />
                Sort by
              </button> */}
              {isDropdownOpen && (
                <ul className="absolute z-50 right-30 top-10 w-48 bg-white border border-gray-300 rounded shadow-lg">
                  <li
                    className={`px-4 py-2 hover:bg-gray-100 cursor-pointer ${sortType === "ASC" && "bg-lightgrey"
                      }`}
                    onClick={() => handleSortFillter("ASC")}
                  >
                    {t("planogram.ascending")}
                  </li>
                  <li
                    className={`px-4 py-2 hover:bg-gray-100 cursor-pointer  ${sortType === "DESC" && "bg-lightgrey"
                      }`}
                    onClick={() => handleSortFillter("DESC")}
                  >
                    {t("planogram.descending")}
                  </li>
                </ul>
              )}
              <button
                onClick={printData}
                disabled={printing || !isEmployeeSelected}
                className={`flex items-center px-4 py-2 text-13 font-medium border rounded transition-all ${(printing || !isEmployeeSelected) ? "opacity-50 cursor-not-allowed" : ""}`}
                title={!isEmployeeSelected ? "Please select an Employee or search by Employee ID to print" : ""}
              >
                {t("DepositInvoice.print")}
                <img
                  src={Export}
                  alt={t("DepositInvoice.print")}
                  className="w-4 h-4 ml-2"
                />
              </button>
              <button
                onClick={handleExport}
                className={`flex items-center gap-2 px-4 py-2 text-13 font-medium border rounded transition-all ${loading ? "opacity-50 cursor-not-allowed" : ""
                  }`}
                disabled={loading}
              >
                {loading ? (
                  <span className="flex items-center gap-2">
                    <span className="loader w-4 h-4 border-2 border-t-2 border-gray-300 rounded-full animate-spin"></span>
                    {t("masterList.exporting")}
                  </span>
                ) : (
                  <>
                    {t("masterList.export")}
                    <img
                      src={Export}
                      alt={t("masterList.export")}
                      className="w-4 h-4 "
                    />
                  </>
                )}
              </button>
              <button
                onClick={handleFilterClick}
                className="flex items-center gap-2 px-4 py-2 text-13 font-normal rounded transition-all"
              >
                <img
                  src={Filter}
                  alt={t("planogram.filter")}
                  className="w-4 h-4 mr-2"
                />
                {t("planogram.filter")}
              </button>


            </div>
          </div>
        </div>
        <div className="sm:hidden flex justify-between items-center p-2 border-b-2 bg-white">
          <div className="flex-grow">
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => handleChange(e.target.value)}
              placeholder={t("planogram.searchPlaceholder")}
              className="w-full px-4 py-2 text-13 border rounded text-gray-600"
              style={{ borderColor: "#e0e0e0" }}
            />
          </div>

          {/* Hamburger menu for Sort, Filter, Export */}
          <div className="flex items-center space-x-2">
            <button
              onClick={printData}
              disabled={printing || !isEmployeeSelected}
              className={`px-2 py-2 text-gray-600 rounded transition-all ${(printing || !isEmployeeSelected) ? "opacity-50 cursor-not-allowed" : ""}`}
            >
              <img
                src={Export}
                alt={t("DepositInvoice.print")}
                className="w-4 h-4"
              />
            </button>
            <button
              onClick={handleExport}
              className={`flex items-center gap-2 px-4 py-2 text-13 font-medium border rounded transition-all ${loading ? "opacity-50 cursor-not-allowed" : ""
                }`}
              disabled={loading}
            >
              {loading ? (
                <span className="flex items-center gap-2">
                  <span className="loader w-4 h-4 border-2 border-t-2 border-gray-300 rounded-full animate-spin"></span>
                  {t("masterList.exporting")}
                </span>
              ) : (
                <>
                  {t("masterList.export")}
                  <img
                    src={Export}
                    alt={t("masterList.export")}
                    className="w-4 h-4 "
                  />
                </>
              )}
            </button>

            <button
              className="px-2 py-2 text-gray-600 rounded transition-all"
              onClick={() => setOpen(!open)}
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16m-7 6h7"
                ></path>
              </svg>
            </button>
          </div>
        </div>
        {open && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-end sm:items-start items-center z-50">
            <div className="relative bg-white shadow-lg w-full max-w-md h-full">
              <div className="absolute z-30 top-[50%] left-[45%]">
                {loadingFilter && <Loader />}
              </div>
              <div className="flex justify-between p-6 border-b-2">
                <div className="text-16 font-bold">
                  {t("visitreports.filters.title")}
                </div>
                <div>
                  <img
                    className="cursor-pointer"
                    onClick={() => setOpen(false)}
                    src={Close}
                    alt=""
                  />
                </div>
              </div>
              <div className="flex flex-col justify-between h-[calc(100vh-100px)] px-12 pt-6 overflow-y-auto scrollbar scrollbar-thin">
                <div className="flex flex-col gap-[30px]">
                  <div className="flex space-x-4">
                    <div className="w-1/2">
                      <Dropdown
                        label={t("visitreports.filters.region")}
                        options={
                          globalFilters?.regions?.map((sales: any) => ({
                            value: sales,
                            label: sales,
                          })) || []
                        }
                        selectedValue={selectedRegion}
                        onChange={(value: any) => {
                          setRegion(value);
                          const data: any = {
                            regions: value ? [value] : [],
                            sales_office_ids: [],
                            territory_ids: [],
                            route_ids: [],
                            endpoint: "visit-summary",
                            start_date: formatCurrentStartDate(new Date(startDate)),
                            end_date: formatCurrentEndDate(new Date(endDate)),
                            positions: [delivery_man]
                          };
                          getGlobalFilters(data);
                        }}
                        placeholder={t("visitreports.filters.selectRegion")}
                      />
                    </div>
                    <div className="w-1/2">
                      <Dropdown
                        label={<span>{t("visitreports.filters.salesOffice")}<span className="text-red-500">*</span></span>}
                        options={
                          globalFilters?.sales_offices?.map((sales: any) => ({
                            value: sales.id,
                            label: sales.name,
                          })) || []
                        }
                        selectedValue={selectedSalesOffice}
                        onChange={(value: any) => {
                          setSelectedSalesOffice(value);
                          const data: any = {
                            regions: selectedRegion ? [selectedRegion] : [],
                            sales_office_ids: value ? [value] : [],
                            territory_ids: [],
                            route_ids: [],
                            endpoint: "visit-summary",
                            start_date: formatCurrentStartDate(new Date(startDate)),
                            end_date: formatCurrentEndDate(new Date(endDate)),
                            positions: [delivery_man]
                          };
                          getGlobalFilters(data);
                        }}
                        disabled={loadingFilter}
                        placeholder={t(
                          "visitreports.filters.selectSalesOffice"
                        )}
                      />
                    </div>
                  </div>
                  {/* <div className="flex gap-4"> */}
                  {/* <div className="w-1/2">
                      <DropdownMulti
                        label={t("visitreports.filters.territoryID")}
                        options={
                          globalFilters?.territories?.map((emp: any) => ({
                            value: String(emp.territory_id),
                            label: emp.territory_identifier,
                          })) || []
                        }
                        selectedValues={territoryId}
                        onChange={setTerritoryId}
                        onClose={handleFiltersUpdate}
                        disabled={!selectedRegion || loadingFilter}
                        placeholder={t(
                          "visitreports.filters.selectTerritoryID"
                        )}
                      />
                    </div> */}

                  {/* <div className="w-full">
                      <DropdownMulti
                        label={<span>{t("visitreports.filters.channelID")}<span className="text-red-500">*</span></span>}
                        options={
                          globalFilters?.channels?.map((emp: any) => ({
                            value: emp.id,
                            label: emp.name,
                          })) || []
                        }
                        selectedValues={channelId}
                        onClose={handleFiltersUpdate}
                        onChange={setChannelId}
                        disabled={loadingFilter}
                        placeholder={t("visitreports.filters.selectChannelID")}
                      />
                    </div> */}
                  {/* </div> */}
                  {/* <div>
                    <div className="w-full">
                      <DropdownMulti
                        label={t("visitreports.filters.routeID")}
                        options={
                          globalFilters?.routes?.map((emp: any) => ({
                            value: `${emp.route_id}`,
                            label: emp.route_identifier,
                          })) || []
                        }
                        selectedValues={routeId}
                        onClose={handleFiltersUpdate}
                        onChange={setRouteId}
                        disabled={!selectedRegion || loadingFilter}
                        placeholder={t("visitreports.filters.selectRouteID")}
                      />
                    </div>
                  </div> */}
                  <div className="flex gap-4">
                    <div className="w-full">
                      <Dropdown
                        label={t("ActivityReport.employeeName")}
                        options={
                          globalFilters?.employees?.map((emp: any) => ({
                            value: emp.id,
                            label: emp.name_eng + " (" + emp.id + ")",
                          })) || []
                        }
                        selectedValue={selectedEmpId}
                        onChange={(value: any) => {
                          setSelectedEmpId(value);
                        }}
                        disabled={loadingFilter || !selectedRegion || !selectedSalesOffice}
                        placeholder={t("ActivityReport.employeeName")}
                        searchable={true}
                      />
                    </div>
                    {/* <div className="w-1/2">
                      <Dropdown
                        label={t("visitreports.filters.userType")}
                        options={
                          globalFilters?.user_types.map((emp: any) => ({
                            value: emp,
                            label: emp,
                          })) || []
                        }
                        selectedValue={userType}
                        onChange={setUserType}
                        disabled={!selectedRegion || loadingFilter}
                        placeholder={t("visitreports.filters.selectUserType")}
                      />
                    </div> */}
                  </div>
                  {/* <div className="flex gap-4"> */}
                  {/* <div className="w-1/2">
                      <Dropdown
                        label={t("visitreports.filters.deliverystatus")}
                        options={globalFilters?.delivery_status.map((status: any) => ({
                          value: status,
                          label: status,
                        }))}
                        selectedValue={DeliveryStatus}
                        onChange={setDeliveryStatus}
                        placeholder={t("visitreports.filters.deliverystatus")}
                      />
                    </div> */}
                  {/* <div className="w-full">
                      <Dropdown
                        label="Delivery Type"
                        options={[
                          { value: "planned", label: "Planned" },
                          { value: "unplanned", label: "Unplanned" },
                        ]}
                        selectedValue={deliveryType}
                        onChange={setDeliveryType}
                        placeholder="Select Delivery Type"
                      />
                    </div> */}
                  {/* </div> */}
                  {/* Date Filter */}
                  <div className="date-range-picker space-y-2 p-4 border-2 rounded-lg border-gray-200 bg-gray-50">
                    <div className="flex items-center justify-between mb-3">
                      <label className="block text-14 font-semibold text-gray-700">
                        {t("visitreports.filters.date")}:
                      </label>
                    </div>
                    <div className="flex space-x-4 justify-between w-full">
                      <div className="w-full">
                        <label className="block text-10 text-gray-700 mb-1">
                          {t("visitreports.filters.date") || "Date"}:
                        </label>
                        <input
                          type="date"
                          className="rounded p-2 border-2 w-full border-gray-400"
                          value={typeof startDate === 'string' ? startDate : (startDate instanceof Date ? startDate.toISOString().split("T")[0] : startDate)}
                          onChange={handleStartDateChange}
                          onKeyDown={(e) => e.preventDefault()}
                          max={new Date().toISOString().split("T")[0]}
                        />
                      </div>
                    </div>
                    <div>
                      <TimeFrameSelector
                        customClass="w-full border-2 rounded p-2 border-gray-300"
                        setSelectTimeFrame={setSelectTimeFrame}
                        timeFrame={timeFrame}
                        setStartDate={setStartDate}
                        setEndDate={setEndDate}
                        excludeMTD={true}
                      />
                    </div>
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="flex justify-between mt-4">
                  <Button
                    onClick={handleClearFilters}
                    label={t("visitreports.filters.clearFilter")}
                    type="grey"
                  />
                  <Button
                    onClick={() => handleApply(sortType)}
                    label={t("visitreports.filters.applyFilter")}
                    type="purple"
                    disabled={loading}
                  />
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="h-[calc(100vh-200px)] md:h-[calc(100vh-125px)] overflow-auto page-container p-2 pt-0 scrollbar scrollbar-thin">
          {!filtersApplied ? (
            <div className="flex items-center justify-center h-full text-gray-500 text-lg font-semibold">
              {landingMessage}
            </div>
          ) : (
            <table className="min-w-full bg-white border border-black-200 table-auto border-separate border-spacing-0">
              <thead className="bg-gray-200 sticky top-[0px] z-20">
                <tr>
                  <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('planningReportTableFields.sequence_number')}</th>
                  <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('planningReportTableFields.employee_id')}</th>
                  <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('planningReportTableFields.employee_name')}</th>
                  <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('planningReportTableFields.supervisor_id')}</th>
                  <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('planningReportTableFields.supervisor_name')}</th>
                  <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('planningReportTableFields.customer_channel_id')}</th>
                  <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('planningReportTableFields.customer_channel_name')}</th>
                  <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('planningReportTableFields.customer_id')}</th>
                  <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('planningReportTableFields.delivery_number')}</th>
                  <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('planningReportTableFields.delivery_date')}</th>
                  <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('planningReportTableFields.time_slot')}</th>
                  <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('planningReportTableFields.delivery_type')}</th>
                  <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('planningReportTableFields.collection_amount')}</th>
                  <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('planningReportTableFields.carton_quantity')}</th>
                  <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('planningReportTableFields.free_carton_quantity')}</th>
                  <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('planningReportTableFields.total_quantity')}</th>
                  <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('planningReportTableFields.total_carton_quantity')}</th>
                  <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('planningReportTableFields.area_street')}</th>
                  <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('planningReportTableFields.customer_name')}</th>
                  <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">{t('planningReportTableFields.customer_mobile_number')}</th>
                </tr>
              </thead>
              <tbody>
                {employees?.items?.length > 0 &&
                  !loading &&
                  employees.items.map((data: any, index: number) => (
                    <tr
                      key={data.delivery_number ?? `${data.emp_id}-${data.customer_id}-${index}`}
                      className="text-16 	hover:bg-gray-50"
                    >
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.sequence_number ?? "-"}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.emp_id ?? "-"}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.emp_name ?? "-"}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.supervisor_id ?? "-"}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.supervisor_name ?? "-"}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.customer_channel_id ?? "-"}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.customer_channel_name ?? "-"}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.customer_id ?? "-"}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.delivery_number ?? "-"}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.delivery_date ? formatDate(data.delivery_date) : "-"}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.time_slot ?? "-"}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.delivery_visit_type ?? "-"}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{formatCollectionAmount(data.amount_to_be_paid)}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{formatQuantity(data.carton_quantity)}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{formatQuantity(data.free_carton_quantity)}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{formatQuantity(data.total_unit_quantity ?? data.total_quantity ?? ((Number(data.carton_quantity) || 0) + (Number(data.free_carton_quantity) || 0)))}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{formatQuantity(data.total_carton_quantity ?? data.total_carton_qty ?? "-")}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{formatAreaStreet(data)}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.customer_name ?? "-"}</td>
                      <td className="px-4 py-3 border text-black-600 whitespace-nowrap">{data.customer_mobile ?? "-"}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          )}
          {filtersApplied && employees?.items?.length === 0 && !loading && (
            <div className="px-4 py-3 border text-center text-black-600 w-full flex items-center justify-center">
              {t("planogram.noresultsfound")}
            </div>
          )}
          {filtersApplied && loading && <Loader />}
        </div>
        <div className="sm:hidden bg-white p-2 border-t-2 mt-auto">
          <PaginationComponent
            totalCount={employees?.total}
            itemsPerPage={employees?.size}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        </div>
        {viewImg && (
          <>
            <ImageDailog
              imageUrl={imgUrl}
              onClose={() => setViewImg(false)}
              title={imgType}
            />
            {imageLoading && (
              <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999 }}>
                <Loader />
              </div>
            )}
          </>
        )}
        <ComponentToPrint
          data={printableData}
          startDate={formatDate(startDate)}
          endDate={formatDate(endDate)}
          headerInfo={printHeaderInfo}
        />
      </div>
    </DashboardPage>
  );
};

export default PlanningReport;
